import React, { useState } from "react";
import {
    Box,
    Grid,
    Typography,
    Paper,
    InputBase,
    IconButton,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useSelector } from "react-redux";

import CustomDataTable from "../../components/DataTable";
import Loader from "../../components/Loader";
import colors from "../../styles/colors";
import { Icons } from "../../assets/Svgs";
import { useFetchBookingsQuery } from "../../store/services/bookingService";
import { IMAGE_URL } from "../../store/services/constants";
import { formatDate, formatDatee, formatTime } from "../../utils/functions";
import { useNavigate } from "react-router-dom";

const Bookings = () => {
    const navigate = useNavigate();
    const { data, isLoading } = useFetchBookingsQuery(1);
    const words = useSelector((state) => state.authReducer.words);

    const [currentPage, setCurrentPage] = useState(1);

    const columns = [
        { field: "id", label: "Booking ID" },
        {
            field: "ad",
            label: "Ad Details",
            render: (value) => (
                <Box>
                    <Typography sx={{ fontFamily: 'PMe', fontSize: 11 }} variant="subtitle2">Name: {value.name}</Typography>
                    <Typography sx={{ fontFamily: 'PMe', fontSize: 11 }} variant="caption">Price: {value.price_hourly}</Typography>
                </Box>
            ),
        },
        {
            field: "user",
            label: "Booked By",
            render: (value) => (
                <Box display="flex" alignItems="center">
                    <img
                        src={IMAGE_URL + value.image || "/default-user.png"}
                        alt={value.username}
                        style={{ width: "30px", height: "30px", borderRadius: "50%", marginRight: "8px" }}
                    />
                    <Box>
                        <Typography sx={{ fontFamily: 'PMe', fontSize: 10 }} >ID: {value.id}</Typography>
                        <Typography sx={{ fontFamily: 'PMe', fontSize: 10 }} >{value.username}</Typography>
                    </Box>
                </Box>
            ),
        },
        { field: "start_date", label: "Start Date", render: (value, record) => <Typography sx={{ fontFamily: 'PMe', fontSize: 11 }}> {formatDate(value)} {record.start_time} </Typography> },
        { field: "end_date", label: "End Date", render: (value, record) => <Typography sx={{ fontFamily: 'PMe', fontSize: 11 }}> {formatDate(value)} {record.end_time} </Typography> },
        { field: "booking_amount", label: "Paid Amount", render: (value) => `OMR    ${value}` },
        { field: "payment_transaction.admin_commission", label: "Admin Amount", render: (value, record) => `OMR ${record.payment_transaction?.admin_commission}` },
        { field: "payment_transaction.user_amount", label: "User Amount", render: (value, record) => `OMR ${record.payment_transaction?.user_amount}` },
        { field: "created_at", label: "Created At", render: (value) => new Date(value).toLocaleDateString() },
        {
            field: "id", label: "View", render: (value) => (
                <Box
                    onClick={() => navigate(`/dashboard/booking-details/${value}`)}
                    sx={{ cursor: 'pointer', }} >
                    <Icons.eyeIcon />
                </Box>
            ),
        }
    ];

    return (
        <Box sx={{ padding: "16px", backgroundColor: "#F5F5F5" }}>
            <Loader open={isLoading} />
            <Grid container spacing={2} alignItems="center">
                {/* Search Bar */}
                <Grid item xs={12} sm={6} md={3} lg={3}>
                    <Paper
                        component="form"
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            borderRadius: "10px",
                            boxShadow: "none",
                            padding: "0.3rem",
                        }}
                    >
                        <Box
                            sx={{
                                width: 2,
                                borderRadius: 5,
                                height: 20,
                                backgroundColor: colors.primary,
                                ml: 2,
                            }}
                        />
                        <InputBase
                            sx={{ ml: 2, flex: 1, fontSize: 13, fontFamily: "PMe" }}
                            placeholder="Search Bookings"
                            inputProps={{ "aria-label": "search bookings" }}
                        />
                        <IconButton aria-label="search">
                            <Icons.searchIcon color={colors.primary} />
                        </IconButton>
                    </Paper>
                </Grid>
            </Grid>

            <Box sx={{ marginTop: "16px", backgroundColor: colors.bg }}>

                <CustomDataTable
                    data={data?.data?.data || []}
                    columns={columns}
                    totalPages={data?.pagination?.last_page || 1}
                    currentPage={currentPage}
                    onPageChange={(page) => setCurrentPage(page)}
                />

            </Box>
        </Box>
    );
};

export default Bookings;
